import React from "react";
import LightsSwitch from "./LightsSwitch";

const DashboardScooter = () => (
  <div className="container-fluid">
    <div className="row pt-4 pb-4">
      <div className="col-4">
        <LightsSwitch />
      </div>
    </div>
  </div>
);

export default DashboardScooter;



// WEBPACK FOOTER //
// ./src/views/pages/scooter/dashboard/index.js